import { History } from '@core/interface/core';
import { Pagination } from '@core/interface/core';

export enum LISTITEM {
  BaseLocation = 'Base Location',
  Make = 'Make',
  Model = 'Model',
  YearofManufacture = 'Year of Manufacture',
  FuelType = 'Fuel Type',
  EngineSize = 'Engine Size',
  Category = 'Category',
  PurchaseLease = 'Purchase/Lease',
}

export class MasterItem {
  id!: number;
  name!: string;
  status!: number;
  is_deleted!: number;
  created_at!: string | Date;
  updated_at!: string | Date;
  history!: History[];
}
export class MasterCommonResponse {
  success!: boolean;
  message!: string;
}
export class MasterResponse extends MasterCommonResponse {
  data!: MasterItem[];
  pagination!: Pagination;
}

export class AddMasterResponse extends MasterCommonResponse {
  data!: MasterItem;
}
export class MasterError extends MasterCommonResponse {
  error?: any;
}

export class DeletedMaster extends MasterCommonResponse {
  id!: number;
}

export class UpdateMasterItem {
  data!: MasterItem[];
}

// DVC

export class VehicleChecklistItem {
  id!: number;
  name!: string;
  major_placeholder!: string;
  minor_placeholder!: string;
  status!: number;
  is_deleted!: number;
  created_at!: string | Date;
  updated_at!: string | Date;
  history!: History[];
}

export class VehicleChecklistResponse extends MasterCommonResponse {
  data!: VehicleChecklistItem[];
  pagination!: Pagination;
}

export class AddVehicleChecklistResponse extends MasterCommonResponse {
  data!: VehicleChecklistItem;
}

export interface ConfigurationPayload {
  search?: string;
  limit?: number;
  page?: number;
  customer_type?: string;
  type?: string;
  customer_id?: number;
  company_id?: number;
  status?: string;
}
